// Drag-handle affordance (grip dots) for draggable worker cards — shown beneath the avatar.
// Hidden at rest; revealed when the consumer's hover root is hovered. The consumer passes that
// root's class via `revealOnHoverOf` so the handle reuses each surface's existing hover container.
import React from 'react';
import { Icon } from '@common/components';

export function ScheduleDragHandle({
  revealOnHoverOf,
}: {
  /** Class of the ancestor whose `:hover` reveals the handle (e.g. the row/card root). */
  revealOnHoverOf: string;
}) {
  return (
    <div className="schedule-drag-handle" aria-hidden>
      <Icon
        size="md"
        icon="gripDotsVertical"
        kind="solid"
        color="midnightLighter"
      />
      <style jsx>{`
        .schedule-drag-handle {
          opacity: 0;
          transition: opacity 0.2s ease;
        }
        :global(.${revealOnHoverOf}:hover) .schedule-drag-handle {
          opacity: 1;
        }
      `}</style>
    </div>
  );
}
